/* Created by Hannah Green on 02/08/2021 for ES-133 */
import React from 'react';
import axios from 'axios';
import { Con, DeleteStyle } from '../styles';
import { useTranslation } from 'react-i18next';
const { Button } = require('components/button');

export default function DeleteWarehouse(props) {
    const { t } = useTranslation();
    const tBase = "views.warehouse_management.components.deleteWarehouse";
    const tr = (key) => t(`${tBase}.${key}`);

    const { id, name, closePopup } = props;

    const deleteWarehouse = async () => {
        try {
            await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/api/v1/eserv-business/warehouse`,
                {
                    type: 'DELETEWAREHOUSE',
                    id,
                }
            );
        } catch (e) {
            console.error(e);
        }
    }

    return (
        <Con>
            <DeleteStyle>
                <div>
                    <label>
                        {tr("Are you sure you want to delete")} {name}?
                    </label>
                    <div>
                        <Button type="submit" onClick={() => { deleteWarehouse() }}>{tr("Yes")}</Button>
                        <Button type="button" onClick={() => { closePopup() }}>No</Button>
                    </div>
                </div>
            </DeleteStyle>
        </Con>
    );
}